<template>
  <div class="auto-loading">
    <van-loading size="24" type="spinner"  vertical color="#1989fa">
      {{ promptCopy }}
    </van-loading>
  </div>
</template>

<script>
import { Loading } from 'vant'

export default {
  components: {
    [Loading.name]: Loading
  },
  data () {
    return {}
  },
  props: {
    promptCopy: {
      type: String,
      default: '加载中...'
    }
  }
}
</script>

<style lang="less" scoped>
  .auto-loading{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 12;
    background: rgba(255,255,255, 0.6);
  }
</style>
